// Validação de CPF e CNPJ pelos dígitos verificadores — espelho de util/DocumentoFiscal.java do backend.
// Existir dos dois lados evita mandar ao servidor um documento que ele vai recusar com 400: a tela avisa antes.
// Se a regra mudar aqui, mude lá também (e vice-versa).
//
// O CNPJ aceita o formato alfanumérico da Receita (a partir de jul/2026: 12 posições com letras ou números
// + 2 dígitos verificadores); o numérico antigo é o caso particular.

// Tira pontuação/espaços e põe em maiúsculas: "123.456.789-09" -> "12345678909"
export const normalizarDocumento = (documento) =>
  (documento == null ? '' : String(documento)).replace(/[^0-9A-Za-z]/g, '').toUpperCase();

const todosIguais = (valor) => /^(.)\1+$/.test(valor);

export function cpfValido(documento) {
  const cpf = normalizarDocumento(documento);
  if (!/^\d{11}$/.test(cpf) || todosIguais(cpf)) return false;
  const digito = (quantidade, pesoInicial) => {
    let soma = 0;
    for (let i = 0; i < quantidade; i++) soma += Number(cpf[i]) * (pesoInicial - i);
    const resto = (soma * 10) % 11;
    return resto === 10 ? 0 : resto;
  };
  return digito(9, 10) === Number(cpf[9]) && digito(10, 11) === Number(cpf[10]);
}

// Cada posição vale (código ASCII - 48): '0'..'9' = 0..9, 'A' = 17 ... 'Z' = 42
export function cnpjValido(documento) {
  const cnpj = normalizarDocumento(documento);
  if (!/^[0-9A-Z]{12}\d{2}$/.test(cnpj) || todosIguais(cnpj)) return false;
  const digito = (pesos) => {
    let soma = 0;
    for (let i = 0; i < pesos.length; i++) soma += (cnpj.charCodeAt(i) - 48) * pesos[i];
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };
  return digito([5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(cnpj[12])
    && digito([6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(cnpj[13]);
}

// CPF (11) ou CNPJ (14); qualquer outro tamanho é inválido
export function documentoValido(documento) {
  const doc = normalizarDocumento(documento);
  if (doc.length === 11) return cpfValido(doc);
  return doc.length === 14 && cnpjValido(doc);
}
